import { types } from 'mobx-state-tree';

const DeliveryEvent = types.model('DeliveryEvent', {
    id: types.maybeNull(types.number),
    event_type: types.maybeNull(types.string),
    dedup_key: types.maybeNull(types.string),
    game_id: types.maybeNull(types.number),
    payload: types.frozen(),
    created_at: types.maybeNull(types.string),
});

const Delivery = types.model('Delivery', {
    id: types.identifierNumber,
    event_id: types.maybeNull(types.number),
    subscription_id: types.maybeNull(types.number),
    status: types.maybeNull(types.string),
    attempt_count: types.optional(types.number, 0),
    next_attempt_at: types.maybeNull(types.string),
    last_response_status: types.maybeNull(types.number),
    last_response_body: types.maybeNull(types.string),
    last_error: types.maybeNull(types.string),
    created_at: types.maybeNull(types.string),
    updated_at: types.maybeNull(types.string),
    event: types.maybeNull(DeliveryEvent),
});

export default Delivery;
